// src/disc/SinyalSirasi.jsx
//
// %50 ve üzerindeki DISC sinyallerini büyükten küçüğe gösteren ortak bileşen.
// ÜÇ YERDE kullanılır: tam rapor anteti, katılımcı PDF'i ve katılımcının envanter
// sonu ekranı. Tek kaynak olmasının sebebi: katılımcının ekranda gördüğü ile
// PDF'te gördüğü BİREBİR aynı kalmalı.

import React from "react";
import { DISC_RENK, DISC_UZERI_YAZI, STIL_ADLARI } from "./discBrand";

// // Önceden raporun tepesinde yalnız EN YÜKSEK sinyal tek rozetle yazıyordu; profilin
// geri kalanı ilk sayfada görünmüyordu. Artık %50 ve üzerindeki TÜM sinyaller
// büyükten küçüğe sıralanır — hem harf boyutuyla hem stil adıyla.
//
// %50 eşiği motorun kuralıdır: uyarlanmış profilde yalnız %50 ve üzerindeki
// sinyaller "ana konuşulan stil" sayılır (bkz. discReportEngine activeAdapted).
// Harf boyutu SIRAYA göre küçülür; renk marka paletinden gelir (discBrand.js).
// Yüzde işaretinin yeri dile bağlı: Türkçede sayının ÖNÜNDE (%53),
// İngilizcede ARKASINDA (53%). Tek biçim sabit yazılıydı; bir dilde yanlıştı.
export default function SinyalSirasi({ baslik, skorlar, tr }) {
  const sirali = ["D", "I", "S", "C"]
    .map((k) => ({ k, v: Math.round(Number(skorlar?.[k]) || 0) }))
    .filter((x) => x.v >= 50)
    .sort((a, b) => b.v - a.v);

  const boyut = [30, 24, 20, 17];
  const adlar = STIL_ADLARI[tr ? "tr" : "en"] || {};

  return (
    <div style={st.sinyalKutu}>
      <p style={st.sinyalBaslik}>{baslik}</p>

      {sirali.length === 0 ? (
        <p style={st.sinyalYok}>
          {tr
            ? "Bu profilde %50 ve üzerinde sinyal yok; dört eğilim de eşik altındadır."
            : "No signal reaches 50% in this profile; all four tendencies stay below the threshold."}
        </p>
      ) : (
        <>
          <div style={st.harfSatiri}>
            {sirali.map((x, i) => (
              <span key={x.k} style={st.harfOge}>
                <span
                  style={{
                    ...st.harfRozet,
                    background: DISC_RENK[x.k],
                    color: DISC_UZERI_YAZI[x.k],
                    width: boyut[i] + 10,
                    height: boyut[i] + 10,
                    fontSize: boyut[i],
                    borderRadius: Math.round(boyut[i] / 3),
                  }}
                >
                  {x.k}
                </span>
                <span style={st.harfYuzde}>{tr ? `%${x.v}` : `${x.v}%`}</span>
              </span>
            ))}
          </div>

          <ol style={st.sinyalListe}>
            {sirali.map((x) => (
              <li key={x.k} style={st.sinyalOge}>
                <span style={{ ...st.sinyalNokta, background: DISC_RENK[x.k] }} />
                <strong>{adlar[x.k]}</strong>
                <span style={st.sinyalDeger}> · {tr ? `%${x.v}` : `${x.v}%`}</span>
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}


/**
 * İki sütunlu pano: solda uyarlanmış, sağda doğal.
 * Üç yerde de aynı bileşen kullanılır ki katılımcının ekranda gördüğü ile
 * PDF'te gördüğü birebir aynı olsun.
 */
export function SinyalPanosu({ adapted, natural, tr = true }) {
  return (
    <div style={st.sinyalIzgara}>
      <SinyalSirasi
        baslik={tr ? "UYARLANMIŞ · şu anki hâl" : "ADAPTED · current state"}
        skorlar={adapted}
        tr={tr}
      />
      <SinyalSirasi
        baslik={tr ? "DOĞAL · temel hâl" : "NATURAL · baseline state"}
        skorlar={natural}
        tr={tr}
      />
    </div>
  );
}

const st = {
  sinyalIzgara: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  sinyalKutu: { padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff" },
  sinyalBaslik: { margin: "0 0 8px", fontSize: 10, letterSpacing: "0.1em", fontWeight: 800, color: "#6b7280" },
  harfSatiri: { display: "flex", alignItems: "flex-end", gap: 9, marginBottom: 9 },
  harfOge: { display: "flex", flexDirection: "column", alignItems: "center", gap: 3 },
  harfRozet: { display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, lineHeight: 1 },
  harfYuzde: { fontSize: 10, fontWeight: 800, color: "#4b5563" },
  sinyalListe: { margin: 0, padding: 0, listStyle: "none", borderTop: "1px solid #eceff3", paddingTop: 7 },
  sinyalOge: { display: "flex", alignItems: "center", gap: 6, fontSize: 11.5, lineHeight: 1.6, color: "#142033" },
  sinyalNokta: { width: 8, height: 8, borderRadius: 2, flex: "0 0 auto" },
  sinyalDeger: { color: "#6b7280", fontWeight: 700 },
  sinyalYok: { margin: 0, fontSize: 11.5, lineHeight: 1.5, color: "#6b7280" },
};
